document.addEventListener('DOMContentLoaded', function() {
  // Get all elements with class js-modal--open
  const modalOpeners = document.querySelectorAll('.js-modal--open');

  // Only proceed if modalOpeners exist
  if (modalOpeners.length > 0) {
    // Add click event listener to each opener
    modalOpeners.forEach(function(opener) {
      opener.addEventListener('click', function(e) {
        e.preventDefault();

        // Get the target modal ID from data-target attribute
        const targetId = this.getAttribute('data-target');

        // Find the target modal
        const targetModal = document.getElementById(targetId);

        // Add is-active class to the modal
        if (targetModal) {
          targetModal.classList.add('is-active');
        }
      });
    });

    // Handle closing modals when clicking the background or close button
    const modalClosers = document.querySelectorAll('.js-modal--close');

    modalClosers.forEach(function(closer) {
      closer.addEventListener('click', function() {
        // Find the parent modal
        const modal = this.closest('.js-modal');

        // Remove is-active class
        if (modal) {
          modal.classList.remove('is-active');
        }
      });
    });
  }
});
